import { FC } from "react";
import { MenuItem } from "./MenuItems/MenuItem";

import { menuPrimaryItems, MenuProps } from "./MenuItems/menuItems";

export const MenuPrimary: FC<React.PropsWithChildren<MenuProps>> = ({
  closeMenuMobile,
  isMobile,
}) => {
  return (
    <nav className="space-y-1 px-2" aria-label="menu">
      {menuPrimaryItems.map((item) => (
        <MenuItem
          item={item}
          key={item.name}
          isMobile={isMobile}
          closeMenuMobile={closeMenuMobile}
        />
      ))}
    </nav>
  );
};
